import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import TablePagination from "@mui/material/TablePagination";

import TableActions from "./TableActions";

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.darker,
    backgroundColor: "white",
    borderRadius: "20px",
    fontSize: "1.6rem",
  },

  select: {
    height: "auto",
    fontSize: "1.6rem",
  },
}));

const CustomTablePagination = props => {
  const classes = useStyles();
  return (
    <TablePagination
      {...props}
      classes={{
        root: classes.root,
        select: classes.select,
        selectLabel: classes.select,
      }}
      slotProps={{
        select: { native: true },
      }}
      ActionsComponent={TableActions}
      rowsPerPageOptions={[10, 20, 50, 100]}
    />
  );
};

export default CustomTablePagination;
